import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import loadingReducer from "../features/auth/loadingSlice";
import interceptorReducer from "../features/auth/interceptorSlice";
import profileReducer from "../features/profile/profileSlice";
import userReducer from "../features/user/userSlice";
import roleReducer from "../features/role/roleSlice";
import lovReducer from "../features/General/lovSlice";
import brandReducer from "../features/brand/brandSlice";
import transporterReducer from "../features/transporter/transporterSlice";
import passwordReducer from "../features/user/passwordSlice";
import unitOfMeasurementReducer from "../features/unitOfMeasurement/unitOfMeasurementSlice";
import warehouseReducer from "../features/warehouse/warehouseSlice";
import vendorReducer from "../features/vendor/vendorSlice";
import vendorDetailReducer from "../features/vendor/vendorDetailSlice";
import productReducer from "../features/product/productSlice";
import itemCategoryReducer from "../features/itemCategory/itemCategorySlice";
import customerCategoryReducer from "../features/customerCategory/customerCategorySlice";
import customerAccountTypeReducer from "../features/customerAccountType/customerAccountTypeSlice";
import itemSegmentReducer from "../features/itemSegment/itemSegmentSlice";
import productGroupMasterReducer from "../features/productGroupMaster/productGroupMasterSlice";
import currencyReducer from "../features/currency/currencySlice";
import purchaseOrderReducer from "../features/purchaseOrder/purchaseOrderSlice";
import purchaseReceiveReducer from "../features/purchaseReceive/purchaseReceiveSlice";
import receiveSessionReducer from "../features/receiveSession/receiveSessionSlice";
import quotationReducer from "../features/quotation/quotationSlice";
import salesOrderReducer from "../features/salesOrder/salesOrderSlice";
import counterSaleReducer from "../features/counterSale/counterSaleSlice";
import invoiceReducer from "../features/invoice/invoiceSlice";
import customerReducer from "../features/customer/customerSlice";
import customerDetailReducer from "../features/customer/customerDetailSlice";
import productGroupReducer from "../features/product/productGroupSlice";
import locationReducer from "../features/location/locationSlice";
import zoneReducer from "../features/zone/zoneSlice";
import compositeProductsReducer from "../features/product/compositeProductSlice";
import locationAccessReducer from "../features/locationAccess/locationAccessSlice";
import purchaseOrderApproverReducer from "../features/purchaseOrderApprover/purchaseOrderApproverSlice";
import salesOrderApproverReducer from "../features/salesOrderApprover/salesOrderApproverSlice";
import historyReducer from "../features/history/historySlice";
import picklistReducer from "../features/picklist/picklistSlice";
import territoryReducer from "../features/territory/territorySlice";
import fiscalCalendarReducer from "../features/fiscalCalendar/fiscalCalendarSlice";
import packingSummaryReducer from "../features/packingSummary/packingSummarySlice";
import packageWorkspaceReducer from "../features/packageWorkspace/packageWorkspaceSlice";
import TenantEmailConfigurationReducer from "../features/tenantEmailConfiguration/tenantEmailConfigurationSlice";
import TenantEmailTemplateReducer from "../features/tenantEmailTemplate/tenantEmailTemplateSlice";
import ManufacturerReducer from "../features/manufacturer/manufacturerSlice";
import deliveryChallanReducer from "../features/deliveryChallan/deliveryChallanSlice";
import shipmentReducer from "../features/Shipment/shipmentSlice";
import salesReturnReducer from "../features/salesReturn/salesReturnSlice";
import salesCreditNoteReducer from "../features/salesCreditNote/salesCreditNoteSlice";
import itemTransactionReducer from "../features/itemTransaction/itemTransactionSlice";
import stockHierarchyReducer from "../features/stockHierarchy/stockHierarchySlice";
import itemAdjustmentReducer from "../features/itemAdjustment/itemAdjustmentSlice";
import transferOrderReducer from "../features/transferOrder/transferOrderSlice";
import backorderReducer from "../features/backorder/backorderSlice";
import importTemplateReducer from "../features/importTemplate/importTemplateSlice";
import salesPersonReducer from "../features/salesPerson/salesPersonSlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";
import stockReportReducer from "../features/stockReport/stockReportSlice";
import stockLedgerReducer from "../features/stockLedger/stockLedgerSlice";
import purchaseReportReducer from "../features/purchaseReport/purchaseReportSlice";
import salesReportReducer from "../features/salesReport/salesReportSlice";
import invoiceReportReducer from "../features/invoiceReport/invoiceReportSlice";
import gstrReportReducer from "../features/gstrReport/gstrReportSlice";
import reportExportReducer from "../features/reportExport/reportExportSlice";
import discountSchemeReducer from "../features/discountScheme/discountSchemeSlice";
import uqcMasterReducer from "../features/uqcMaster/uqcMasterSlice";
import itemDefaultBinReducer from "../features/itemDefaultBin/itemDefaultBinSlice";
/**** Admin Reducer ****/
import tenantReducer from "../features/admin/tenant/tenantSlice";
import tenantInquiryReducer from "../features/admin/tenantInquiry/tenantInquirySlice";
import emailProviderReducer from "../features/admin/emailProvider/emailProviderSlice";
import emailConfigurationReducer from "../features/admin/tenant/emailConfigurationSlice";
import emailTemplateReducer from "../features/admin/emailTemplate/emailTemplateSlice";
import emailPlaceholderReducer from "../features/admin/emailTemplate/emailPlaceholderSlice";
import eInvoiceConfigurationReducer from "../features/admin/eInvoiceConfiguration/eInvoiceConfigurationSlice";
import invoiceRepairReducer from "../features/admin/invoiceRepair/invoiceRepairSlice";
import eInvoiceReducer from "../features/eInvoice/eInvoiceSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    loading: loadingReducer,
    interceptor: interceptorReducer,
    profile: profileReducer,
    lov: lovReducer,
    user: userReducer,
    role: roleReducer,
    brand: brandReducer,
    transporter: transporterReducer,
    password: passwordReducer,
    unitOfMeasurement: unitOfMeasurementReducer,
    warehouse: warehouseReducer,
    vendor: vendorReducer,
    vendorDetail: vendorDetailReducer,
    product: productReducer,
    compositeProducts: compositeProductsReducer,
    itemCategory: itemCategoryReducer,
    customerCategory: customerCategoryReducer,
    customerAccountType: customerAccountTypeReducer,
    itemSegment: itemSegmentReducer,
    productGroupMaster: productGroupMasterReducer,
    currency: currencyReducer,
    purchaseOrder: purchaseOrderReducer,
    purchaseReceive: purchaseReceiveReducer,
    receiveSession: receiveSessionReducer,
    quotation: quotationReducer,
    salesOrder: salesOrderReducer,
    counterSale: counterSaleReducer,
    invoice: invoiceReducer,
    customer: customerReducer,
    customerDetail: customerDetailReducer,
    productGroup: productGroupReducer,
    location: locationReducer,
    zone: zoneReducer,
    locationAccess: locationAccessReducer,
    purchaseOrderApprover: purchaseOrderApproverReducer,
    salesOrderApprover: salesOrderApproverReducer,
    history: historyReducer,
    picklist: picklistReducer,
    territory: territoryReducer,
    fiscalCalendar: fiscalCalendarReducer,
    packingSummary: packingSummaryReducer,
    packageWorkspace: packageWorkspaceReducer,
    tenantEmailConfiguration: TenantEmailConfigurationReducer,
    tenantEmailTemplate: TenantEmailTemplateReducer,
    manufacturer: ManufacturerReducer,
    deliveryChallan: deliveryChallanReducer,
    shipment: shipmentReducer,
    salesReturn: salesReturnReducer,
    salesCreditNote: salesCreditNoteReducer,
    itemTransaction: itemTransactionReducer,
    stockHierarchy: stockHierarchyReducer,
    itemAdjustment: itemAdjustmentReducer,
    transferOrder: transferOrderReducer,
    backorder: backorderReducer,
    importTemplate: importTemplateReducer,
    salesPerson: salesPersonReducer,
    dashboard: dashboardReducer,
    stockReport: stockReportReducer,
    stockLedger: stockLedgerReducer,
    purchaseReport: purchaseReportReducer,
    salesReport: salesReportReducer,
    invoiceReport: invoiceReportReducer,
    gstrReport: gstrReportReducer,
    reportExport: reportExportReducer,
    discountScheme: discountSchemeReducer,
    uqcMaster: uqcMasterReducer,
    itemDefaultBin: itemDefaultBinReducer,
    /* Admin */
    tenant: tenantReducer,
    tenantInquiry: tenantInquiryReducer,
    emailProvider: emailProviderReducer,
    emailConfiguration: emailConfigurationReducer,
    emailTemplate: emailTemplateReducer,
    emailPlaceholder: emailPlaceholderReducer,
    eInvoiceConfiguration: eInvoiceConfigurationReducer,
    invoiceRepair: invoiceRepairReducer,
    eInvoice: eInvoiceReducer,
  },
});

export default store;
